import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { CalendarIcon, ClockIcon } from 'lucide-react';
interface DateTimePickerProps {
  selectedDate: Date | null;
  onDateChange: (date: Date | null) => void;
  minDate?: Date;
}
export const DateTimePicker: React.FC<DateTimePickerProps> = ({
  selectedDate,
  onDateChange,
  minDate = new Date()
}) => {
  return <div className="space-y-4" data-id="element-45">
      <div data-id="element-46">
        <label className="flex items-center text-sm text-white text-opacity-70 mb-2" data-id="element-47">
          <CalendarIcon size={16} className="text-primary mr-2" data-id="element-48" />
          Select Date
        </label>
        <DatePicker selected={selectedDate} onChange={onDateChange} minDate={minDate} dateFormat="MMMM d, yyyy" className="input-field w-full" calendarClassName="bg-card border border-primary rounded-lg" dayClassName={() => 'text-white hover:bg-primary hover:text-background'} data-id="element-49" />
      </div>
      <div data-id="element-50">
        <label className="flex items-center text-sm text-white text-opacity-70 mb-2" data-id="element-51">
          <ClockIcon size={16} className="text-primary mr-2" data-id="element-52" />
          Select Time
        </label>
        <DatePicker selected={selectedDate} onChange={onDateChange} showTimeSelect showTimeSelectOnly timeIntervals={15} timeCaption="Time" dateFormat="h:mm aa" className="input-field w-full" data-id="element-53" />
      </div>
    </div>;
};
// Export DatePicker for use in other components
export { DatePicker };